import { render, staticRenderFns } from "./openCourse.vue?vue&type=template&id=1bdb6317&scoped=true&"
import script from "./openCourse.vue?vue&type=script&lang=js&"
export * from "./openCourse.vue?vue&type=script&lang=js&"
import style0 from "./openCourse.vue?vue&type=style&index=0&id=1bdb6317&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdb6317",
  null
  
)

export default component.exports